<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Parameter auto-tuners'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true"
                           :disabled="!$can('update', 'Autotuner')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <autotuner-dialog v-model="dialog" :item="editedItem"
                                                v-on:doreload="refresh()"></autotuner-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="autotuner"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.autotuner_id }}</td>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.target }}</td>
                            <td>{{ props.item.active ? "Yes" : "No" }}</td>
                            <td>{{ props.item.adjustment_frequency}}</td>
                            <td>
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Autotuner')"
                                    @click="$can('update', 'Autotuner') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Autotuner')"
                                    @click="$can('update', 'Autotuner') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getAutotuner, deleteAutotuner} from '../helper'
import AutotunerDialog from "../components/AutotunerDialog";

export default {
    name: 'Autotuners',
    components: {AutotunerDialog},
    data() {
        return {
            dialog: false,
            headers: [
                {text: this.$options.filters.translate('ID'), value: 'autotuner_id'},
                {text: this.$options.filters.translate('Name'), value: 'name'},
                {text: this.$options.filters.translate('Target'), value: 'target'},
                {text: this.$options.filters.translate('Active'), value: 'active'},
                {text: this.$options.filters.translate('Adjustment Frequency'), value: 'adjustment_frequency'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            autotuner: [],
            editedItem: {},
            search: '',
            search2: '',
            timeout: null,
        }
    },

    mounted() {
        this.initialize()
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    methods: {
        initialize() {
            this.refresh()
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteAutotuner({
                    'autotuner_id': item.autotuner_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getAutotuner({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.autotuner = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
